import React, { useState, useEffect } from 'react'

const SquareTabbar = ({ list, handler, classes }) => {
  const [currentTab, setCurrentTab] = useState(list[0])
  const toggleClasses = (element) => {
    if (element) {
      element.classList.toggle('text-blue-600')
      element.classList.toggle('border-blue-500')
      element.classList.toggle('bg-white')
    }
  }

  const innerhandler = (event) => {
    toggleClasses(document.getElementById(currentTab))
    toggleClasses(document.getElementById(event.target.id))
    setCurrentTab(event.target.id)
    handler(event.target.innerText)
  }

  useEffect(() => {
    toggleClasses(document.getElementById(list[0]))
  }, [])

  return (
    <nav className={'-mb-px inline-flex ' + classes} aria-label='Tabs'>
      {list.map((item) => {
        return (
          <span
            key={item}
            onClick={innerhandler}
            id={item}
            className='border border-sm bg-white border-gray-200 text-gray-700 mr-1 rounded py-2 px-4 font-semibold hover:border-blue-500 hover:border-lg hover:text-blue-600 cursor-pointer'
          >
            {item}
          </span>
        )
      })}
    </nav>
  )
}

export default React.memo(SquareTabbar)
